module.exports = __webpack_public_path__ + "d2648d02567b06b1017bba49b16e56cc.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_pig.png
// module id = 88
// module chunks = 0